import { Stack, Typography } from "@mui/material";
import { TickCircle } from "iconsax-react";

interface IErrorAlert {
  msgTitle: string;
  msgDesc?: string;
}

export default function SuccessAlert({
  msgTitle,
  msgDesc,
}: Readonly<IErrorAlert>) {
  return (
    <Stack
      width="100%"
      bgcolor={(theme) => theme.palette.others.doneBg}
      color={(theme) => theme.palette.others.done}
      gap="4px"
      borderColor={(theme) => theme.palette.others.done}
      sx={{
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "8px",
        py: "12px",
        px: "16px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="start"
        gap="2px"
      >
        <TickCircle size="24" variant="Outline" />
        <Typography variant="h6DemiBold">{msgTitle}</Typography>
      </Stack>
      <Typography px="24px" variant="captionRegular">
        {msgDesc}
      </Typography>
    </Stack>
  );
}
